function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.94,2C7.356,2,2,6.822,2,12.746,2,19.026,8.018,24.1,15.134,23.437v2.444c.024-.008,0,1.194,1.194.539l.645-.413c1.352-.867,8.128-5.526,8.839-12.119a9.746,9.746,0,0,0,.068-1.14C25.881,6.822,20.524,2,13.94,2ZM9.761,13.94H8.567a.6.6,0,0,1-.6-.6V12.149a.6.6,0,0,1,.6-.6H9.761a.6.6,0,0,1,.6.6v1.194A.6.6,0,0,1,9.761,13.94Zm4.776,0H13.343a.6.6,0,0,1-.6-.6V12.149a.6.6,0,0,1,.6-.6h1.194a.6.6,0,0,1,.6.6v1.194A.6.6,0,0,1,14.537,13.94Zm4.776,0H18.119a.6.6,0,0,1-.6-.6V12.149a.6.6,0,0,1,.6-.6h1.194a.6.6,0,0,1,.6.6v1.194A.6.6,0,0,1,19.314,13.94Z",
  transform: "translate(-2 -2)"
});

var SvgChatsIcon = function SvgChatsIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23.881,
    height: 24.615,
    viewBox: "0 0 23.881 24.615",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChatsIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chats_icon.1f73ad52.svg";
export { ForwardRef as ReactComponent };